import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import cls from './pattern-lab-title.module.css';

type PatternStudyTitleProps = {
    title: string;
};

export const PatternLabTitle = memo(({ title }: PatternStudyTitleProps) => {
    const { t } = useTranslation('pattern-studio');

    return (
        <div className={cls.root}>
            <div className={cls.content}>
                <span>{t('patternStats.patternId')}:</span>
                <span className={cls.title}>{title}</span>
            </div>
        </div>
    );
});

PatternLabTitle.displayName = 'PatternStudyTitle';
